import { showNotification } from '../../util/showNotification';

export const onLoginAction = (userName: string | undefined) => {
    const asUsername = userName ? ` as ${userName}` : '';
    showNotification({
        severity: 'success',
        title: `Successfully logged in${asUsername}`,
    });
};
